import { ListPlus, Share2, Gift, DollarSign, Bitcoin, HeartHandshake, PackageOpen, Heart } from "lucide-react";

const steps = [
  {
    icon: ListPlus,
    step: "1",
    title: "Build your list",
    description:
      "Create a wishlist for birthdays, weddings, baby showers — or just because you're tired of getting socks. Paste a product link, name your favourite stores, or just describe what you're after. Want cash instead? Set up a fund. Into crypto? Add your wallet. Rather give than receive? Nominate a charity. Your list, your way.",
  },
  {
    icon: Share2,
    step: "2",
    title: "Share the hint",
    description:
      "Send your list to the people who need it — one tap via WhatsApp, iMessage, email, or just copy the link. They don't need an account. They just open it and see exactly what you'd love.",
  },
  {
    icon: Gift,
    step: "3",
    title: "Claim & Spark",
    description:
      "When someone picks a gift, they claim it so nobody else buys the same thing (goodbye, duplicate toasters). They can also leave a personal 'Spark' note — a message you'll only see once the gift arrives. It's the bit that makes it feel real.",
  },
  {
    icon: PackageOpen,
    step: "4",
    title: "Unbox & reveal",
    description:
      "Gift arrives? Open it in Unboxing Mode. Confirm you've received it, reveal the Spark note from your giver, and enjoy that moment of someone genuinely nailing it.",
  },
  {
    icon: Heart,
    step: "5",
    title: "Send your thanks",
    description:
      "Say thank you properly. Send a free digital card with AI-generated artwork, or go the extra mile with an eco-friendly printed card on recycled paper. Gratitude shouldn't cost the earth — literally. 🌿",
  },
];

const giftOptions = [
  { icon: Gift, label: "Specific Gifts", desc: "Exactly what they want" },
  { icon: DollarSign, label: "Cash Funds", desc: "Contribute to something big" },
  { icon: Bitcoin, label: "Crypto", desc: "Send digital currency" },
  { icon: HeartHandshake, label: "Charities", desc: "Donate in their name" },
];

const HowItWorks = () => {
  return (
    <section className="py-20 px-4 hero-gradient">
      <div className="container max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-foreground mb-4">
          How Does It Work?
        </h2>
        <p className="text-center text-muted-foreground mb-12 max-w-2xl mx-auto">
          It's simpler than you think. Here's the whole process.
        </p>
        <div className="space-y-8">
          {steps.map((s) => (
            <div
              key={s.step}
              className="flex gap-5 items-start bg-card rounded-2xl p-6 border border-border card-elevated"
            >
              <div className="w-12 h-12 rounded-xl bg-primary flex items-center justify-center flex-shrink-0">
                <s.icon className="h-6 w-6 text-primary-foreground" />
              </div>
              <div>
                <h3 className="font-bold text-foreground mb-1">
                  Step {s.step}: {s.title}
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {s.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Gift options callout */}
        <div className="mt-12">
          <p className="text-center text-sm font-medium text-muted-foreground mb-5 uppercase tracking-wider">
            Every way to give & receive
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
            {giftOptions.map((opt) => (
              <div
                key={opt.label}
                className="flex flex-col items-center text-center bg-card rounded-xl p-4 border border-border hover:border-primary/30 transition-colors"
              >
                <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center mb-2">
                  <opt.icon className="h-5 w-5 text-primary" />
                </div>
                <p className="text-sm font-semibold text-foreground">{opt.label}</p>
                <p className="text-xs text-muted-foreground mt-0.5">{opt.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
